import { Modal } from "@/shared/modal";
import { ReactNode, useState } from "react";
import { ModalProps } from "antd";

export function FormInModal({
  title,
  form,
  trigger,
  modalProps,
}: {
  title: ReactNode;
  trigger: (open: () => void) => ReactNode;
  form: (close: () => void) => ReactNode;
  modalProps?: ModalProps & { footer?: ReactNode; "data-testid"?: string };
}) {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <div
      // disable bubbling of events and trigger events in parent components
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div>{trigger(open)}</div>
      <Modal title={title} open={isOpen} onCancel={close} {...modalProps}>
        {form(close)}
      </Modal>
    </div>
  );
}
